<template>
    <div>
        <b-row>
            <b-col class="freight-title">
                {{ $t('freight.freightTitle') }}
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div class="freight-grid">
                    <b-form-group :label="$t('freight.chooseFreightOptionText')">
                        <b-form-select v-model="formData.freightSelected" :options="freightOptions"></b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('freight.quantity')" v-if="postnordIsSelected(formData.freightSelected)">
                        <b-form-select v-model="formData.packageQuantity" :options="packageQuantity"></b-form-select>
                    </b-form-group>
                </div>
            </b-col>
        </b-row>
        <b-row v-if="storeIsSelected(formData.freightSelected)">
            <b-col>
                <b-form-group :label="$t('freight.chooseStoreOptionText')">
                    <b-form-select v-model="formData.storeSelected" :options="freightStoreOptions"></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    name: 'FreightOptions',
    props: {
        formData: {},
        freightOptions: {},
        freightStoreOptions: {}
    },
    data() {
        return {
            packageQuantity: [
                1, 2, 3, 4, 5
            ]
        }
    },
    methods: {
        postnordIsSelected(freightOption) {
            return freightOption === 'postnord';
        },
        storeIsSelected(freightOption) {
            return freightOption === 'return_to_store';
        },
        onUpdate() {

        },
    },
}
</script>
<style scoped>
.freight-title {
    font-weight: 500;
    text-transform: uppercase;
    font-size: 14px;
    padding-bottom: 0.5rem;
}

.freight-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}
</style>
